import React from 'react'
import { motion } from 'framer-motion'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import HealthIdeaProjects from '../molecules/HealthCareAppComponents/HealthIdeaProjects/HealthIdeaProjects'
import HealthFeatureBox from '../molecules/HealthCareAppComponents/HealthFeatureBox/HealthFeatureBox'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import HealthCustom from '../molecules/HealthCareAppComponents/HealthCustom/HealthCustom'
import HealthKeyFeatures from '../molecules/HealthCareAppComponents/HealthKeyFeatures/HealthKeyFeatures'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { getPageData, useData } from '../../app/helper/functions'
import ReliabilityHeathCareSteps from '../molecules/HealthCareAppComponents/ReliabilityHealthcareSteps/ReliabilityHeathcareSteps'

const HealthCarePage = () => {
    const { data } = useData();
    const healthCareData = getPageData(data, 'healthCarePage');
    return (
        <div className='overflow-x-hidden'>
            <div className='bg-healthcare-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col md:flex-row pt-20 md:pt-52 px-4 md:px-0'>
                        <motion.img 
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                            src={images.HEALTHCAREIMAGE} 
                            className='w-full md:w-[45%] mb-8 md:mb-0' 
                        />
                        <motion.div 
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                            className='text-white flex flex-col gap-2 h-auto md:h-[500px] relative w-full md:w-[50%] items-start md:items-end pr-0 md:pr-24'
                        >
                            <div className='capitalize font-bold text-4xl md:text-7xl leading-snug'>{healthCareData.title}</div>
                            <div className='font-medium text-lg md:text-2xl text-start md:text-end'>{healthCareData.description}</div>
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.6 }}
                >
                    <Heading className='bg-darkGreyPrimary py-8 md:py-12 px-4 md:px-0'
                        subTitle='Advantages of choosing custom healthcare App development'
                        text="The healthcare industry is quickly incorporating technology to optimize patient results and operations. Tailored applications address the diverse needs of providers, patients, and administrators, facilitating smooth communication and efficient workflows." 
                    />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0.6, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <ReliabilityHeathCareSteps healthCareData={healthCareData}/>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <Heading className='bg-darkGreyPrimary py-8 md:py-12 px-4 md:px-0'
                        subTitle='How we develop healthcare Apps'
                        text="Our organized approach to healthcare app development guarantees compliance, user-friendliness, and growth potential." 
                    />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.1 }}
                    transition={{ duration: 0.3, delay: 0.2 }}
                >
                    <HealthIdeaProjects healthCareData={healthCareData}/>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <HealthFeatureBox />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <HealthKeyFeatures healthCareData={healthCareData}/>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <ProjectDisplay />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <AppsFaq />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <HealthCustom />
                </motion.div>

                <DefaultFooter />
            </div>
        </div>
    )
}

export default HealthCarePage
